import * as React from "react";
import {
  ExperienceProvider,
  ExperienceSelector,
} from "@origin-digital/features";
import { getMbox } from "./mbox";
import NavbarDropdown from "./NavbarDropdown";
import { updateNavStructure } from "./ABTestUtils";

const renderNavbarDropdown = (navItem, index) => (
  <NavbarDropdown
    icon={navItem.label.icon}
    smallIcon={navItem.label.smallIcon}
    menuItems={navItem.menuItems}
    key={index + navItem.label}
    menuId={navItem.label.text.replace(/ /g, "_")}
    menuLabel={navItem.label.text}
    aria-label={navItem.label.text}
  >
    {navItem.label.text}
  </NavbarDropdown>
);

export const NavbarDropdownsList = ({ navStructure }) => {
  const mbox = getMbox();
  return mbox ? (
    <ExperienceProvider mboxes={[mbox]}>
      <ExperienceSelector mbox={mbox}>
        {(content) => (
          <>
            {updateNavStructure(content, navStructure).map(
              renderNavbarDropdown
            )}
          </>
        )}
      </ExperienceSelector>
    </ExperienceProvider>
  ) : (
    navStructure.map(renderNavbarDropdown)
  );
};
